/**
 * SEO-Friendly Filter Logic (Antigravity)
 * Handles redirection for Metal filters to use clean Tag URLs.
 */

$(document).ready(function () {

    // Unified Handler for Desktop (.filtermetal-seo) and Mobile (.filtermetalmobile-seo)
    // We utilize unique classes to bypass legacy scripts
    // CRITICAL: Unbind any conflicting handlers from custom.js to prevent "Double Toggle" or interference
    $(document).off('click', '.filtermetal, .filtermetalmobile');
    $(document).off('click', '.remvefilter, .reset-filter');

    $('body').on('click', '.filtermetal-seo, .filtermetalmobile-seo', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var $this = $(this);
        var handle = $this.attr('data-handle');

        // 1. Visual Update (Optimistic UI) 
        // Toggle the active class AND the SVG checkmark immediately.
        if ($this.hasClass('filtermetalmobile-seo')) {
            $this.toggleClass('slide-active');
        } else {
            $this.toggleClass('r-active');
        }

        // 2. Get Base Collection URL
        var collectionUrl = $this.closest('[data-collection-url]').attr('data-collection-url');
        if (!collectionUrl) collectionUrl = $this.parent().attr('data-collection-url');
        if (!collectionUrl) {
            var pathParts = window.location.pathname.split('/');
            if (pathParts.length >= 3 && pathParts[1] === 'collections') {
                collectionUrl = '/collections/' + pathParts[2];
            } else {
                collectionUrl = window.location.pathname;
            }
        }
        if (collectionUrl.endsWith('/')) collectionUrl = collectionUrl.slice(0, -1);


        // 3. Determine Active State from DOM (The Source of Truth)
        // We use the DOM classes because we just toggled one above.
        var activeTags = [];
        $('.filtermetal-seo.r-active, .filtermetalmobile-seo.slide-active').each(function () {
            var t = $(this).attr('data-tag');
            if (t && activeTags.indexOf(t) === -1) {
                activeTags.push(t);
            }
        });

        var clickedTag = $this.attr('data-tag');
        var isCurrentlyActive = (activeTags.indexOf(clickedTag) > -1);
        var otherActiveCount = activeTags.filter(function (t) { return t !== clickedTag; }).length;

        // 4. Construct URL Parameters
        // PRESERVE existing params (like sort_by, page, other active filters)
        // This fixes the bug where other filters were wiped out.
        var params = new URLSearchParams(window.location.search);

        // Identify the param name for Metal
        var metalParamName = 'filter.v.option.color'; // Default
        var safeVal = clickedTag.replace(/'/g, "\\'");
        var $input = $('input[value="' + safeVal + '"]').first();
        if ($input.length) {
            metalParamName = $input.attr('name');
        } else {
            var $anyMetal = $('input[name^="filter.v.option.color"], input[name^="filter.v.option.metal"]').first();
            if ($anyMetal.length) metalParamName = $anyMetal.attr('name');
        }

        // REMOVE existing metal params to rebuild them cleanly from our activeTags list
        params.delete(metalParamName);

        // ADD current metal params
        activeTags.forEach(function (tag) {
            params.append(metalParamName, tag);
        });

        // Reset pagination
        params.delete('page');

        // 5. Routing Logic & AJAX
        if (collectionUrl) {

            // Scenario 1: Exactly 1 Filter (Active) AND No other params (Pure Single) -> User wants Clean URL redirect
            if (activeTags.length === 1) {
                var singleTag = activeTags[0];
                var $singleEl = $('.filtermetal-seo[data-tag="' + singleTag + '"], .filtermetalmobile-seo[data-tag="' + singleTag + '"]').first();
                var singleHandle = $singleEl.attr('data-handle');

                var hasOtherParams = false;
                params.forEach(function (value, key) {
                    if (key !== metalParamName) hasOtherParams = true;
                });

                if (!hasOtherParams && singleHandle) {
                    window.history.pushState({ path: collectionUrl + '/' + singleHandle }, '', collectionUrl + '/' + singleHandle);
                } else {
                    window.history.pushState({ path: collectionUrl }, '', collectionUrl);
                }
            } else if (activeTags.length === 0) {
                window.history.pushState({ path: collectionUrl }, '', collectionUrl);
            } else {
                // Multi Filters -> Base URL (Neat & Clean strategy)
                window.history.pushState({ path: collectionUrl }, '', collectionUrl);
            }

            // AJAX Fetch
            // We ALWAYS send the full params to the server so it renders correctly.
            var sectionId = 'main-collection';
            var $msgContainer = $('#CollectionAjaxContent');
            if ($msgContainer.length) {
                var foundId = $msgContainer.closest('[data-section-id]').attr('data-section-id');
                if (foundId) sectionId = foundId;
            }

            var fetchUrl = collectionUrl + '/?' + params.toString() + '&section_id=' + sectionId + '&_t=' + new Date().getTime();
            $msgContainer.css('opacity', '0.5');

            fetch(fetchUrl)
                .then(function (response) { return response.text(); })
                .then(function (html) {
                    var $response = $(html);
                    var newContent = $response.find('#CollectionAjaxContent').html();
                    if (!newContent) {
                        if ($response.find('.collection-content').length) {
                            newContent = $response.find('.collection-content #CollectionAjaxContent').html();
                        } else {
                            var $inner = $response.filter('#CollectionAjaxContent');
                            if ($inner.length) newContent = $inner.html();
                        }
                    }
                    if (newContent) {
                        $msgContainer.html(newContent);

                        // CRITICAL: Re-sync Visual State (Same as removal handler)

                    }
                    $msgContainer.css('opacity', '1');
                })
                .catch(function (err) {
                    console.error('Antigravity Filter Error:', err);
                    window.location.href = collectionUrl + '/?' + params.toString();
                });
        }
    });

    // Unified Removal Handler for "Applied Filters" and "Clear All"
    // We delegate to body to handle dynamically added elements
    $('body').on('click', '.active-filter a, .reset-filter', function (e) {
        e.preventDefault();

        // 1. Optimistic UI: Immediate Feedback
        var $clicked = $(this);
        // If "Clear All"
        if ($clicked.hasClass('reset-filter')) {
            // Hide the entire applied filter wrapper immediately
            $('.applied__filter_wrapper').fadeOut(200);
            // Also visually uncheck everything in the menu
            $('.filtermetal-seo, .filtermetalmobile-seo').removeClass('r-active slide-active');
        }
        // If Single Filter Removal
        else {
            $clicked.closest('.active-filter').fadeOut(200);
            // Visually uncheck specific tag if possible
            var href = $clicked.attr('href');
            // Try to guess tag from URL or DOM? 
            // Ideally we just hide the pill. AJAX will fix the rest.
        }


        var href = $(this).attr('href');
        // Safety check
        if (!href) return;

        // 2. Parse 'Next State' params from the clicked link
        // The href of a removal link already contains the params for the *result* state.
        var parser = document.createElement('a');
        parser.href = href;
        var nextSearchParams = new URLSearchParams(parser.search);

        // Base Collection URL
        var collectionUrl = parser.pathname;
        if (collectionUrl.endsWith('/')) collectionUrl = collectionUrl.slice(0, -1);

        // 3. AJAX Fetch Logic
        var sectionId = 'main-collection';
        var $msgContainer = $('#CollectionAjaxContent');
        if ($msgContainer.length) {
            var foundId = $msgContainer.closest('[data-section-id]').attr('data-section-id');
            if (foundId) sectionId = foundId;
        }

        // Clean URL construction
        // Use params.toString() directly. 
        var searchStr = nextSearchParams.toString();
        var fetchUrl = collectionUrl + '/?';
        if (searchStr) fetchUrl += searchStr + '&';
        fetchUrl += 'section_id=' + sectionId + '&_t=' + new Date().getTime();

        $msgContainer.css('opacity', '0.5');

        fetch(fetchUrl)
            .then(function (response) { return response.text(); })
            .then(function (html) {
                var $response = $(html);

                // ROBUST EXTRACTION:
                // 1. Try finding ID inside response
                var newContent = $response.find('#CollectionAjaxContent').html();

                // 2. Try identifying wrapper class if ID not found inner
                if (!newContent) {
                    if ($response.find('.collection-content').length) {
                        newContent = $response.find('.collection-content #CollectionAjaxContent').html();
                    } else {
                        // 3. Maybe the response IS the element (if section rendering returns just the block)
                        var $inner = $response.filter('#CollectionAjaxContent');
                        if ($inner.length) newContent = $inner.html();
                        else {
                            // 4. Fallback: Try to find the grid/filter wrapper directly
                        }
                    }
                }

                if (newContent) {
                    $msgContainer.html(newContent);

                    // Re-sync Visual State for Menu Ticks
                    var $newHTML = $(html);
                    var $serverFilters = $newHTML.find('.filtermetal-seo, .filtermetalmobile-seo');

                    if ($serverFilters.length > 0) {
                        var activeTagsFromServer = [];
                        $serverFilters.filter('.r-active, .slide-active').each(function () {
                            var t = $(this).attr('data-tag');
                            if (t) activeTagsFromServer.push(t);
                        });

                        $('.filtermetal-seo, .filtermetalmobile-seo').each(function () {
                            var $this = $(this);
                            var tag = $this.attr('data-tag');
                            var shouldBeActive = (activeTagsFromServer.indexOf(tag) > -1);

                            if (shouldBeActive) {
                                $this.addClass('r-active');
                                if ($this.hasClass('filtermetalmobile-seo')) $this.addClass('slide-active');
                            } else {
                                $this.removeClass('r-active');
                                $this.removeClass('slide-active');
                            }
                        });
                    } else {
                        // Fallback Sync using params
                        var activeTagsInParams = [];
                        nextSearchParams.forEach(function (value, key) {
                            if ($('.filtermetal-seo[data-tag="' + value + '"]').length > 0 ||
                                $('.filtermetalmobile-seo[data-tag="' + value + '"]').length > 0) {
                                activeTagsInParams.push(value);
                            }
                        });
                        $('.filtermetal-seo, .filtermetalmobile-seo').each(function () {
                            var $this = $(this);
                            var tag = $this.attr('data-tag');
                            var shouldBeActive = (activeTagsInParams.indexOf(tag) > -1);

                            if (shouldBeActive) {
                                $this.addClass('r-active');
                                if ($this.hasClass('filtermetalmobile-seo')) $this.addClass('slide-active');
                            } else {
                                $this.removeClass('r-active');
                                $this.removeClass('slide-active');
                            }
                        });
                    }
                } else {
                    console.warn('Antigravity: Missing #CollectionAjaxContent. Loading full page.');
                    window.location.href = href;
                    return;
                }
                $msgContainer.css('opacity', '1');

                // 4. URL History Update
                var metalTagsInParams = [];
                var hasOtherParams = false;

                nextSearchParams.forEach(function (value, key) {
                    if (key === 'page' || key === 'section_id' || key === '_t') return;
                    var isMetal = false;
                    if ($('.filtermetal-seo[data-tag="' + value + '"]').length > 0) {
                        metalTagsInParams.push(value);
                        isMetal = true;
                    }
                    if (!isMetal) hasOtherParams = true;
                });

                if (metalTagsInParams.length === 1 && !hasOtherParams) {
                    var singleTag = metalTagsInParams[0];
                    var $el = $('.filtermetal-seo[data-tag="' + singleTag + '"]').first();
                    var handle = $el.attr('data-handle');
                    if (handle) {
                        window.history.pushState({ path: collectionUrl + '/' + handle }, '', collectionUrl + '/' + handle);
                    } else {
                        window.history.pushState({ path: collectionUrl }, '', collectionUrl);
                    }
                } else if (metalTagsInParams.length === 0 && !hasOtherParams) {
                    window.history.pushState({ path: collectionUrl }, '', collectionUrl);
                } else {
                    window.history.pushState({ path: collectionUrl }, '', collectionUrl);
                }

            })
            .catch(function (err) {
                console.error('Antigravity Filter Removal Error:', err);
                window.location.href = href;
            });
    });

});
